import axios from "axios";
import { BreadthResponse, MacroResponse, PulseCategory, PulseEarningsRow, PulseSignalsResponse, PulseStreamResponse, PulseSummaryResponse, ShortMover } from "@/models/pulse";

const BASE = "/interface/api/pulse";

export const getPulseSignals = async (params: { limit?: number; categories?: PulseCategory[]; perCategory?: number; universeId?: number } = {}, signal?: AbortSignal) => {
    const res = await axios.get<PulseSignalsResponse>(`${BASE}/signals`, {
        params: {
            limit: params.limit,
            categories: params.categories?.join(",") || undefined,
            per_category: params.perCategory,
            universe_id: params.universeId,
        },
        signal,
    });
    return res.data;
};

export const getPulseStream = async (params: { since?: string; limit?: number; categories?: PulseCategory[]; universeId?: number } = {}, signal?: AbortSignal) => {
    const res = await axios.get<PulseStreamResponse>(`${BASE}/stream`, {
        params: { since: params.since, limit: params.limit, categories: params.categories?.join(",") || undefined, universe_id: params.universeId },
        signal,
    });
    return res.data;
};

export const getPulseSummary = async (signal?: AbortSignal) => {
    const res = await axios.get<PulseSummaryResponse>(`${BASE}/summary`, { signal });
    return res.data;
};

export const getPulseMacro = async (signal?: AbortSignal) => {
    const res = await axios.get<MacroResponse>(`${BASE}/macro`, { signal });
    return res.data;
};

export const getPulseShortMovers = async (params: { universeId?: number; direction?: "up" | "down" | "abs"; limit?: number } = {}, signal?: AbortSignal) => {
    const res = await axios.get<{ rows: ShortMover[] }>(`${BASE}/short_movers`, {
        params: { universe_id: params.universeId, direction: params.direction, limit: params.limit },
        signal,
    });
    return res.data.rows;
};

export const getPulseEarnings = async (params: { universeId?: number; limit?: number } = {}, signal?: AbortSignal) => {
    const res = await axios.get<{ pending?: boolean; rows: PulseEarningsRow[] }>(`${BASE}/earnings`, {
        params: { universe_id: params.universeId, limit: params.limit },
        signal,
    });
    return res.data;
};

export const getPulseBreadth = async (universeId: number, signal?: AbortSignal) => {
    const res = await axios.get<BreadthResponse>(`${BASE}/breadth`, { params: { universe_id: universeId }, signal });
    return res.data;
};
